<template>
  <v-select
    v-model="selected"
    label="Order Type"
    :items="items"
    :loading="isLoading"
    outlined
    dense
    clearable
    item-text="name"
    item-value="value"
  />
</template>

<script>
export default {
  name: "AppOrderTypesAutocomplete",
  data: () => ({
    isLoading: false,
    items: [
      { id: 1, name: "Asap", value: 1 },
      { id: 2, name: "Not Asap", value: 0 },
    ],
    selected: "",
  }),
  watch: {
    selected: function () {
      this.$emit("input", this.selected);
    },
  },
};
</script>
